import React, { Component, Fragment } from "react"
import { Switch, Route, BrowserRouter, Redirect } from 'react-router-dom'
import jwt from 'jsonwebtoken'

import Login from "./components/Login"
import Register from "./components/Register"
import Home from "./components/Home"
import UserNav from "./components/universal/UserNav"
import DicomViewer from "./components/DicomViewer"

let token = localStorage.getItem('access_token');

jwt.decode(token);

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
      (localStorage.getItem('access_token') ? (
        <Component {...props}/>
      ) : (
        <Redirect to={{
          pathname: '/',
          state: { from: props.location }
        }}/>
        )
      )
    )}/>
); 

const PublicRoute = ({ component: Component, ...rest}) => (
    <Route {...rest} render={props => (
        localStorage.getItem('access_token') ?
        (<Redirect to={{
            pathname: '/home',
            state: { from: props.location }
        }}/>
        ) : (
            <Component {...props}/>
        )  
    )}/>
);

class Routes extends Component {
    
    render(){
        return (
            <BrowserRouter>
                <Switch>
                    <PublicRoute exact path="/" component={Login}/>
                    <PublicRoute path="/cadastro" component={Register}/>
                    <PrivateRoute path='/visualizador' component={DicomViewer}/>
                    <Fragment>
                        <UserNav/>
                        <PrivateRoute path="/home" component={Home}/>
                    </Fragment>
                    
                </Switch>
            </BrowserRouter>
        )
    }
}

export default Routes;